import { render, staticRenderFns } from "./ReadChat.vue?vue&type=template&id=6b426918&scoped=true&"
import script from "./ReadChat.vue?vue&type=script&lang=js&"
export * from "./ReadChat.vue?vue&type=script&lang=js&"
import style0 from "./ReadChat.vue?vue&type=style&index=0&id=6b426918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b426918",
  null
  
)

export default component.exports